import React from 'react';
import { Box, Tabs, Tab, Dialog, DialogTitle, DialogContent } from '@mui/material';
import SplashPageConfig from './SplashPageConfig';
import Faq from './Faq';

function TabPanel({ children, value, index }) {
    return (
        <div role="tabpanel" hidden={value !== index} aria-labelledby={`tab-${index}`}>
            {value === index && <Box sx={{ pt: 2 }}>{children}</Box>}
        </div>
    );
}


export default function SplashPageDialog({ open = true, onClose = () => { }, domain = {}, onSplashPageUpdated = () => { } }) {
    const [value, setValue] = React.useState(0);

    const handleChange = (event, newVal) => setValue(newVal);

    const handleSaveSuccess = (domainId, payload) => {
        onSplashPageUpdated(domainId, payload);
        onClose();
    };

    
    return (
        <Dialog fullWidth maxWidth="lg" open={open} onClose={onClose}>
            <DialogTitle id='alert-dialog-title'>Customize Splash page</DialogTitle>
            <DialogContent>
                <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                    <Tabs value={value} onChange={handleChange} aria-label="splash page tabs">
                        <Tab label="Products" id="tab-0" aria-controls="tabpanel-0" />
                        <Tab label="Frequently Asked Questions" id="tab-1" aria-controls="tabpanel-1" />
                    </Tabs>
                </Box>

                <TabPanel value={value} index={0}>
                    <SplashPageConfig
                        domain={domain}
                        onSaveSuccess={handleSaveSuccess}
                    />
                </TabPanel>

                <TabPanel value={value} index={1}>
                    <Faq domain={domain} onSaveSuccess={handleSaveSuccess} />
                </TabPanel>
            </DialogContent>

        </Dialog>
    );
}
